import React from 'react';
import { Box } from '@chakra-ui/react';
import { ff } from '../../../theme';

/** Lime checkmark badge — withdrawal success modal. */
const WalletWithdrawalSuccessIllustration: React.FC = () => (
  <Box position="relative" w="88px" h="88px" mx="auto" mb={5} aria-hidden>
    <Box
      position="absolute"
      top="6px"
      left="4px"
      w="18px"
      h="3px"
      borderRadius="full"
      bg={ff.ink}
      opacity={0.7}
      transform="rotate(-35deg)"
    />
    <Box
      position="absolute"
      top="2px"
      left="14px"
      w="12px"
      h="3px"
      borderRadius="full"
      bg={ff.faint}
      opacity={0.8}
      transform="rotate(-20deg)"
    />
    <Box
      position="absolute"
      top="10px"
      left="18px"
      w="10px"
      h="3px"
      borderRadius="full"
      bg={ff.muted}
      opacity={0.55}
      transform="rotate(-8deg)"
    />
    <Box
      w="88px"
      h="88px"
      borderRadius="full"
      bg={ff.lime}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        as="svg"
        viewBox="0 0 24 24"
        w="42px"
        h="42px"
        fill="none"
        stroke={ff.ink}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5 13l4 4L19 7" />
      </Box>
    </Box>
  </Box>
);

export default WalletWithdrawalSuccessIllustration;
